export default __webpack_public_path__ + "static/media/roboto-v20-cyrillic_latin-regular.4f862c8b.svg";